// extracted by mini-css-extract-plugin
export default {"editorContent":"BulletedList_editorContent__GZwWN","bulletedListBox":"BulletedList_bulletedListBox__jRhgG","listItemBox":"BulletedList_listItemBox__n5gmj"};